import { createRequestActionTypes } from '../../helpers'

export const FETCH_SUGGESTIONS = createRequestActionTypes(
  'SEARCH',
  'FETCH_SUGGESTIONS'
)
export const FETCH_SEARCH = createRequestActionTypes('SEARCH', 'FETCH_SEARCH')
